import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { motion } from 'framer-motion';
import { styled } from '@mui/material/styles';

/**
 * Tab Navigation Component
 * Animated tab switcher with smooth transitions
 */

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `2px solid ${theme.palette.divider}`,
  minHeight: 56,
  
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: 3,
    borderRadius: '3px 3px 0 0',
  },
  
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '1rem',
    color: theme.palette.text.secondary,
    transition: 'all 0.3s ease-in-out',
    
    '&:hover': {
      color: theme.palette.primary.main,
    },
    
    '&.Mui-selected': {
      color: theme.palette.primary.main,
    },
  },
}));

const TabContent = styled(motion.div)({
  width: '100%',
});

const TabNavigation = ({ tabs = [], value = 0, onChange, activeContent = null }) => {
  return (
    <Box>
      <StyledTabs value={value} onChange={onChange} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} id={`tab-${index}`} />
        ))}
      </StyledTabs>

      {/* Tab Content */}
      {activeContent && (
        <TabContent
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          sx={{ mt: 3 }}
        >
          {activeContent}
        </TabContent>
      )}
    </Box>
  );
};

export default TabNavigation;
